(() => {
  const GetCookie = (name) => {
    var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
    return v ? v[2] : null;
  };

  const handleCustomerDiscounting = async () => {
    let code = GetCookie("discount_code");

    if (!window && !window.theme) {
      return;
    }

    if (window.theme.customer.enableCustomerTagDiscounting === false) {
      return;
    }

    if (!window.theme.customer.id) {
      return;
    }

    const splitTagsAndCodes =
      window.theme.customer.customerTagsDiscountCodes.split(",");

    let discountCode = "";

    splitTagsAndCodes.forEach((tagAndCode) => {
      if (!tagAndCode.includes(":")) {
        return;
      }

      const tag = tagAndCode.split(":")[0].toLowerCase();
      const code = tagAndCode.split(":")[1];

      if (window.theme.customer.tags.includes(tag)) {
        if (tag === "active_subscriber" && discountCode != "") {
          return;
        }

        discountCode = code;
      }
    });

    if (!code && discountCode) {
      fetch(`/discount/${discountCode}`)
        .then((res) => res.text())
        .catch(console.error);
    }
  };

  const init = () => {
    handleCustomerDiscounting();
  };

  document.addEventListener("DOMContentLoaded", init);
})();
$(document).ready(function () {

  $('.recharge__widget--item').eq(0).addClass('active');
   var data_value=$('.recharge__widget--item').eq(0).attr("data-value");
    const url = new URL(window.location.href);
  if (url.pathname.includes("/products/")) {
      url.searchParams.set("selling_plan", data_value);
      window.history.pushState({}, "", url);
  }
  $(document).on("click", ".recharge__widget--item", function () {
    var $el = $(this),
      data_target = $el.attr("data-value");
    console.log($el, data_target);
    if (data_target) {
      $('[name="selling_plan"]').val(data_target);
      const url = new URL(window.location.href);
      if (url.pathname.includes("/products/")) {
      url.searchParams.set("selling_plan", data_target);
      window.history.pushState({}, "", url);
      }
      $(".recharge__widget--item").removeClass("active"); // Remove class from all
      $el.addClass("active");
    } else {
      console.error("data-target is not defined.");
    }
  });
});
